{
    "Quick-Search-Fields": [
        {
            "label": "VenueName",
            "columnname": "VenueName",
            "placeholder": "VenueName",
            "width": "",
            "datatype": "string",
            "isLarge": true
        },
        {
            "label": "Symbol",
            "columnname": "Symbol",
            "placeholder": "Symbol",
            "width": "",
            "datatype": "string",
            "isLarge": true
        },
        {
            "label": "OrderID",
            "columnname": "OrderID",
            "placeholder": "OrderID",
            "width": "",
            "datatype": "string",
            "isLarge": true
        }
    ],
    "Grid-Columns": [
        {
            "display": "true",
            "ui_columnname": "action",
            "db_columnname": "action",
            "datatype": "char",
            "mappingkey": "action",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "O",
            "db_columnname": "isOrder",
            "datatype": "boolean",
            "mappingkey": "isOrder",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
         {
            "display": "true",
            "ui_columnname": "orderDateTime",
            "db_columnname": "orderDateTime",
            "datatype": "string",
            "mappingkey": "orderDateTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "orderID",
            "db_columnname": "orderID",
            "datatype": "string",
            "mappingkey": "orderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
         {
            "display": "true",
            "ui_columnname": "symbol",
            "db_columnname": "symbol",
            "datatype": "string",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "side",
            "db_columnname": "side",
            "datatype": "string",
            "mappingkey": "side",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "quantity",
            "db_columnname": "quantity",
            "datatype": "float",
            "mappingkey": "quantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "orderType",
            "db_columnname": "orderType",
            "datatype": "string",
            "mappingkey": "orderType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "limitPrice",
            "db_columnname": "limitPrice",
            "datatype": "float",
            "mappingkey": "limitPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "customer",
            "db_columnname": "customer",
            "datatype": "string",
            "mappingkey": "customer",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "R",
            "db_columnname": "isRoute",
            "datatype": "boolean",
            "mappingkey": "isRoute",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "routeID",
            "db_columnname": "routeID",
            "datatype": "string",
            "mappingkey": "routeID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "routeDateTime",
            "db_columnname": "routeDateTime",
            "datatype": "string",
            "mappingkey": "routeDateTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "routeShares",
            "db_columnname": "routeShares",
            "datatype": "float",
            "mappingkey": "routeShares",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "routePrice",
            "db_columnname": "routePrice",
            "datatype": "float",
            "mappingkey": "routePrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "VenueName",
            "db_columnname": "venueName",
            "datatype": "string",
            "mappingkey": "venueName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "E",
            "db_columnname": "isExecution",
            "datatype": "boolean",
            "mappingkey": "isExecution",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "execID",
            "db_columnname": "execID",
            "datatype": "string",
            "mappingkey": "execID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "executionTime",
            "db_columnname": "execDateTime",
            "datatype": "string",
            "mappingkey": "execDateTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "execShares",
            "db_columnname": "execShares",
            "datatype": "float",
            "mappingkey": "execShares",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "execPrice",
            "db_columnname": "execPrice",
            "datatype": "float",
            "mappingkey": "execPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "execBroker",
            "db_columnname": "execBroker",
            "datatype": "string",
            "mappingkey": "execBroker",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "execMarket",
            "db_columnname": "execMarket",
            "datatype": "string",
            "mappingkey": "execMarket",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "capacity",
            "db_columnname": "capacity",
            "datatype": "string",
            "mappingkey": "capacity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "liquidityFlag",
            "db_columnname": "liquidityFlag",
            "datatype": "string",
            "mappingkey": "liquidityFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "timeInForce",
            "db_columnname": "timeInForce",
            "datatype": "string",
            "mappingkey": "timeInForce",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "notHeld",
            "db_columnname": "notHeld",
            "datatype": "boolean",
            "mappingkey": "notHeld",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "directed",
            "db_columnname": "directed",
            "datatype": "boolean",
            "mappingkey": "directed",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "splHandlingCode",
            "db_columnname": "splHandlingCode",
            "datatype": "string",
            "mappingkey": "splHandlingCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "isReportableSymbol",
            "db_columnname": "isReportableSymbol",
            "datatype": "boolean",
            "mappingkey": "isReportableSymbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "SNP500",
            "db_columnname": "SNP500",
            "datatype": "boolean",
            "mappingkey": "SNP500",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "notionalValue",
            "db_columnname": "notionalValue",
            "datatype": "float",
            "mappingkey": "notionalValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "isMultiLeg",
            "db_columnname": "isMultiLeg",
            "datatype": "boolean",
            "mappingkey": "isMultiLeg",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "instrumentType",
            "db_columnname": "instrumentType",
            "datatype": "string",
            "mappingkey": "instrumentType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "FOK",
            "db_columnname": "fillOrKill",
            "datatype": "boolean",
            "mappingkey": "fillOrKill",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AON",
            "db_columnname": "allOrNone",
            "datatype": "boolean",
            "mappingkey": "allOrNone",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
         {
            "display": "true",
            "ui_columnname": "IOC",
            "db_columnname": "immediateOrCancel",
            "datatype": "boolean",
            "mappingkey": "immediateOrCancel",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "DNIR",
            "db_columnname": "doNotIncreaseReduce",
            "datatype": "boolean",
            "mappingkey": "doNotIncreaseReduce",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "furtherRoutable",
            "db_columnname": "furtherRoutable",
            "datatype": "boolean",
            "mappingkey": "furtherRoutable",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "principalExec",
            "db_columnname": "principalExec",
            "datatype": "boolean",
            "mappingkey": "principalExec",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "cancelOrderTime",
            "db_columnname": "cancelOrderTime",
            "datatype": "string",
            "mappingkey": "cancelOrderTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "cancelQuantity",
            "db_columnname": "cancelQuantity",
            "datatype": "string",
            "mappingkey": "cancelQuantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
         {
            "display": "true",
            "ui_columnname": "senderIMID",
            "db_columnname": "senderIMID",
            "datatype": "string",
            "mappingkey": "senderIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "orderState",
            "db_columnname": "orderState",
            "datatype": "string",
            "mappingkey": "orderState",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "orderCondition",
            "db_columnname": "orderCondition",
            "datatype": "string",
            "mappingkey": "orderCondition",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "liquidityAdded",
            "db_columnname": "liquidityAdded",
            "datatype": "boolean",
            "mappingkey": "liquidityAdded",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "venueNetPayment",
            "db_columnname": "venueNetPayment",
            "datatype": "float",
            "mappingkey": "venueNetPayment",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "priceImproved",
            "db_columnname": "priceImproved",
            "datatype": "string",
            "mappingkey": "priceImproved",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "priceImprovement",
            "db_columnname": "priceImprovement",
            "datatype": "string",
            "mappingkey": "priceImprovement",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "bidPrice",
            "db_columnname": "bidPrice",
            "datatype": "float",
            "mappingkey": "bidPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "bidSize",
            "db_columnname": "bidSize",
            "datatype": "float",
            "mappingkey": "bidSize",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "askPrice",
            "db_columnname": "askPrice",
            "datatype": "float",
            "mappingkey": "askPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "askSize",
            "db_columnname": "askSize",
            "datatype": "float",
            "mappingkey": "askSize",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "lastPrice",
            "db_columnname": "lastPrice",
            "datatype": "float",
            "mappingkey": "lastPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "lastSize",
            "db_columnname": "lastSize",
            "datatype": "float",
            "mappingkey": "lastSize",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "customerType",
            "db_columnname": "customerType",
            "datatype": "string",
            "mappingkey": "customerType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "senderIMID",
            "db_columnname": "senderIMID",
            "datatype": "string",
            "mappingkey": "senderIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
              {
            "display": "true",
            "ui_columnname": "settlementType",
            "db_columnname": "settlementType",
            "datatype": "string",
            "mappingkey": "settlementType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
              {
            "display": "true",
            "ui_columnname": "venueMPID",
            "db_columnname": "venueMPID",
            "datatype": "string",
            "mappingkey": "venueMPID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
              {
            "display": "true",
            "ui_columnname": "routeType",
            "db_columnname": "routeType",
            "datatype": "string",
            "mappingkey": "routeType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "venueRate",
            "db_columnname": "venueRate",
            "datatype": "float",
            "mappingkey": "venueRate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "bdOrder",
            "db_columnname": "bdOrder",
            "datatype": "boolean",
            "mappingkey": "bdOrder",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "reportDate",
            "db_columnname": "reportDate",
            "datatype": "string",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "omsSystem",
            "db_columnname": "omsSystem",
            "datatype": "string",
            "mappingkey": "omsSystem",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "inputFileName",
            "db_columnname": "inputFileName",
            "datatype": "string",
            "mappingkey": "inputFileName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
         {
            "display": "true",
            "ui_columnname": "createUser",
            "db_columnname": "createUser",
            "datatype": "string",
            "mappingkey": "createUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "createdDate",
            "db_columnname": "createdDate",
            "datatype": "string",
            "mappingkey": "createdDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
         {
            "display": "true",
            "ui_columnname": "updatedDate",
            "db_columnname": "updatedDate",
            "datatype": "string",
            "mappingkey": "updatedDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
      ],
      "removedColumns":[
        {
            "display": "true",
            "ui_columnname": "expiryDateTime",
            "db_columnname": "expiryDateTime",
            "datatype": "string",
            "mappingkey": "expiryDateTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "customerType",
            "db_columnname": "customerType",
            "datatype": "string",
            "mappingkey": "customerType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "settlementType",
            "db_columnname": "settlementType",
            "datatype": "string",
            "mappingkey": "settlementType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "venueMIC",
            "db_columnname": "venueMIC",
            "datatype": "string",
            "mappingkey": "venueMIC",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "venueMPID",
            "db_columnname": "venueMPID",
            "datatype": "string",
            "mappingkey": "venueMPID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "routeType",
            "db_columnname": "routeType",
            "datatype": "string",
            "mappingkey": "routeType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "venueRate",
            "db_columnname": "venueRate",
            "datatype": "float",
            "mappingkey": "venueRate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "venueNetPayment",
            "db_columnname": "venueNetPayment",
            "datatype": "float",
            "mappingkey": "venueNetPayment",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "officialOpenPrice",
            "db_columnname": "officialOpenPrice",
            "datatype": "float",
            "mappingkey": "officialOpenPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "officialClosePrice",
            "db_columnname": "officialClosePrice",
            "datatype": "float",
            "mappingkey": "officialClosePrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "oeBidPrice",
            "db_columnname": "oeBidPrice",
            "datatype": "float",
            "mappingkey": "oeBidPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "oeAskPrice",
            "db_columnname": "oeAskPrice",
            "datatype": "float",
            "mappingkey": "oeAskPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "source",
            "db_columnname": "source",
            "datatype": "string",
            "mappingkey": "source",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "quoteSequenceNumber",
            "db_columnname": "quoteSequenceNumber",
            "datatype": "string",
            "mappingkey": "quoteSequenceNumber",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "lastSequenceNumber",
            "db_columnname": "lastSequenceNumber",
            "datatype": "string",
            "mappingkey": "lastSequenceNumber",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "orderCondition",
            "db_columnname": "orderCondition",
            "datatype": "string",
            "mappingkey": "orderCondition",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },

        {
            "display": "true",
            "ui_columnname": "bdOrder",
            "db_columnname": "bdOrder",
            "datatype": "boolean",
            "mappingkey": "bdOrder",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "mpid",
            "db_columnname": "mpid",
            "datatype": "string",
            "mappingkey": "mpid",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "inputFileID",
            "db_columnname": "inputFileID",
            "datatype": "int",
            "mappingkey": "inputFileID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "lastUpdatedBy",
            "db_columnname": "lastUpdatedBy",
            "datatype": "string",
            "mappingkey": "lastUpdatedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
     ]
}